import { createSlice } from "@reduxjs/toolkit";
import { save } from "../cardPrompt/cardPromptSlice";
import { MessageStatus } from "./types";

interface WorkspaceState {
  message?: string;
  status?: string;
}

const initialState: WorkspaceState = {
  message: undefined,
  status: undefined
};

const workspaceSlice = createSlice({
  name: "workspace",
  initialState: initialState,
  reducers: {
    notify: (state, action) => {
      const { message, status } = action.payload;
      state.message = message;
      state.status = status;
    },
    clearNotification: state => {
      state.status = undefined;
      state.message = undefined;
    }
  },
  extraReducers: builder => {
    builder.addCase(save.fulfilled, (state: WorkspaceState) => {
      state.status = MessageStatus.success;
      // state.message = "Card prompt saved successfully";
    });
  }
});

export default workspaceSlice.reducer;
export const { notify, clearNotification } = workspaceSlice.actions;
